import styled from 'styled-components';

export const StyledSection = styled.section`
    ${props => props.theme &&
        props.theme.ns &&
        props.theme.ns().spacing.getSpacingMixin()
}
`;
